import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { rootRoutes } from "../../../routes";
import Tool from "components/app/tool/Tool";
import ScreenToolsList from "./list";
import ScreenConfigAndPrints from "./config";
import ScreentConfigsAndPrintsActivityLog from "./activityLog";
import TrainingCertificate from "./trainingCertificate";
import Groups from "./groups";
import Releases from "./releases";
import CNRActivity from "components/app/tool/cnractivity";
import IdlEvents from "components/app/tool/list/idl-events/IdlEvents";
import LogsPdf from "./logsPdf";
import ScreenCNRProcessingStatus from "./cnrProcessing";
import FeatureFlags from "components/app/tool/feature-flags/FeatureFlags";
import ScreenPortsCargoList from "./portsCargoList";
import ScreenFaq from "./faq";
import ScreenDocSyncCheck from "./docSyncCheck";
import ScreenCNRPatches from "./cnrPatches";
import ScreenInstanceManager from "./instanceManager";

const toolRoutes = rootRoutes.children.app.children.tools.children;
type ScreenToolProps = React.PropsWithChildren<{}>;
function ScreenTool(props: ScreenToolProps) {
	return (
		<Tool>
			<Switch>
				<Route exact path={toolRoutes.list.path} component={ScreenToolsList} />
				<Route
					path={toolRoutes.list.children.configPrint.path}
					component={ScreenConfigAndPrints}
				/>
				<Route
					path={toolRoutes.list.children.configPrintActivityLog.path}
					component={ScreentConfigsAndPrintsActivityLog}
				/>
				<Route
					path={toolRoutes.list.children.auditLog.path}
					component={ScreentConfigsAndPrintsActivityLog}
				/>
				<Route
					path={toolRoutes.list.children.trainingCertificate.path}
					component={TrainingCertificate}
				/>
				<Route
					path={
						toolRoutes.list.children.trainingCertificate.children.approvals.path
					}
					component={TrainingCertificate}
				/>
				<Route path={toolRoutes.list.children.groups.path} component={Groups} />
				<Route
					path={toolRoutes.list.children.releases.path}
					component={Releases}
				/>
				<Route
					path={toolRoutes.list.children.logsPdf.path}
					component={LogsPdf}
				/>
				<Route
					path={toolRoutes.list.children.docSyncCheck.path}
					component={ScreenDocSyncCheck}
				/>
				<Route
					path={toolRoutes.list.children.cnrPatches.path}
					component={ScreenCNRPatches}
				/>
				<Route
					path={toolRoutes.list.children.cnractivity.path}
					component={CNRActivity}
				/>
				<Route
					path={toolRoutes.list.children.cnrProcessingStatus.path}
					component={ScreenCNRProcessingStatus}
				/>
				<Route
					path={toolRoutes.list.children.idlEvents.path}
					component={IdlEvents}
				/>
				<Route
					path={toolRoutes.list.children.featureFlags.path}
					component={FeatureFlags}
				/>
				<Route
					path={toolRoutes.list.children.portsCargoList.path}
					component={ScreenPortsCargoList}
				/>
				<Route path={toolRoutes.list.children.faq.path} component={ScreenFaq} />
				<Route
					path={toolRoutes.list.children.instances.path}
					component={ScreenInstanceManager}
				/>
				<Route render={RedirectComponent} />
			</Switch>
		</Tool>
	);
}

function RedirectComponent() {
	return <Redirect to={toolRoutes.list.url()} />;
}
export default ScreenTool;
